import * as Styled from "./styled";

import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchHubDetails } from "../../../reducers/hub";
import Sheet from "react-modal-sheet";

export default function ContentBottomSheet(props) {
  const dispatch = useDispatch();
  const cityName = useSelector((state) => state.hub.name);
  let drawerBleeding = props.displayPopupCity ? 56 : 24;
  const snapPoints = [0.99, drawerBleeding];
  const sheetRef = useRef(null);

  const snapTo = (i) => sheetRef.current?.snapTo(i);
  useEffect(() => {
    dispatch(fetchHubDetails());
    if (props.showSheet) {
      snapTo(0);
    } else {
      snapTo(1);
    }
  }, [dispatch, props.showSheet, props.displayPopupCity]);

  const toggleDrawer = () => {
    props.onShowSheet(!props.showSheet);
  };

  return (
    <Styled.ContentSheet
      renderbackdrop={"false"}
      ref={sheetRef}
      detent={"content-height"}
      isOpen={true}
      onClose={() => {
        toggleDrawer();
      }}
      snapPoints={snapPoints}
      initialSnap={0}
      onSnap={(snapIndex) => {
        if (!props.showSheet && snapIndex === 0) props.onShowSheet(true);
      }}
    >
      <Sheet.Container>
        <Styled.PopupsSheetHeader onClick={() => toggleDrawer()}>
          <Styled.Puller />
          {props.displayPopupCity ? (
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: 0,
                  marginLeft: 16,
                  marginRight: 16,
                  marginBottom: 16,
                }}
              >
                <Styled.Title sx={{}}>{cityName}</Styled.Title>
                <Styled.SheetState onClick={() => toggleDrawer()}>
                  {props.showSheet ? "Collapse" : "Expand"}
                </Styled.SheetState>
              </div>
              <Styled.Spacer />
            </div>
          ) : null}
        </Styled.PopupsSheetHeader>
        <Sheet.Content>
          <Styled.ContentContainer>{props.children}</Styled.ContentContainer>
        </Sheet.Content>
      </Sheet.Container>
    </Styled.ContentSheet>
  );
}
